"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reactRedux = require("react-redux");

var _FromUrlPanel = _interopRequireDefault(require("../../components/browser/FromUrlPanel"));

var _Actions = require("../../actions/Actions");

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onBack: function onBack() {
      dispatch((0, _Actions.goBack)());
    }
  };
};

var _default = (0, _reactRedux.connect)(null, mapDispatchToProps)(_FromUrlPanel.default);

exports.default = _default;
module.exports = exports.default;